const pins=[
  ['provider_request','stg-mee-provider-request.md','a7d47eeeb287397446af84bbbceaa156c8eafe3a84cc0682c6483bf6fef9e998'],
  ['setup_checklist','stg-mee-setup-checklist.md','398c59ec5f236f00c1f5cc19663d1b72f06016a2b43516faac521109f8857422']
];
const off=['request_sent','runtime_verified','resources_created','quote_requested','signing_enabled','execution_enabled','fee_collection_enabled'];
const exact=(v,keys)=>v!==null&&typeof v==='object'&&!Array.isArray(v)
  &&Object.keys(v).length===keys.length&&keys.every(k=>Object.hasOwn(v,k));
const sha=async text=>Array.from(new Uint8Array(await crypto.subtle.digest('SHA-256',new TextEncoder().encode(text)))).map(b=>b.toString(16).padStart(2,'0')).join('');
export const validQuoteResearch=async value=>{
  try{
    if(!exact(value,['status','snapshot_date','release_commit','deployment_context','scope','documents',...off])
      ||value.status!=='source_research_only'||value.snapshot_date!=='2026-11-03'
      ||value.release_commit!=='61001d0f53540c5bdf00bd79ad64995401446b09'
      ||value.deployment_context!=='none_reported_at_snapshot'||value.scope!=='source_code_not_runtime_authority'
      ||off.some(k=>value[k]!==false)||!Array.isArray(value.documents)||value.documents.length!==2)return false;
    for(let i=0;i<2;i++){
      const doc=value.documents[i],pin=pins[i];
      if(!exact(doc,['kind','filename','content','sha256'])||doc.kind!==pin[0]||doc.filename!==pin[1]||doc.sha256!==pin[2]
        ||typeof doc.content!=='string'||doc.content.length<100||doc.content.length>12000)return false;
      if(await sha(doc.content)!==pin[2])return false;
    }
    return true;
  }catch{return false;}
};